import { render, staticRenderFns } from "./v-password-field.vue?vue&type=template&id=2b6b9d7a&"
import script from "./v-password-field.vue?vue&type=script&lang=js&"
export * from "./v-password-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports